module.exports = __webpack_public_path__ + "static/proje-maarif-83a917e43f92df5e1978d851a1884798.png";